import { actions } from '@/modules/SuiviFactures/store/modules/SuiviFinancier/actions';
import { state, SuiviFinancierState } from '@/modules/SuiviFactures/store/modules/SuiviFinancier/state';
import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { mutations } from './mutations';
import { getters } from './getters';

const module: Module<SuiviFinancierState, RootState> = {
    state,
    actions,
    mutations,
    getters,
};

export default module;
export type { SuiviFinancierState };
